import { useEffect, useState } from 'react';
import { Sparkles, Settings2, CalendarDays, FileText, ScrollText, CheckCircle2 } from 'lucide-react';
import SettingsTab from './components/SettingsTab';
import CalendarTab from './components/CalendarTab';
import DraftsTab from './components/DraftsTab';
import AuditTab from './components/AuditTab';

const TABS = [
  ['settings', 'Settings', Settings2],
  ['calendar', 'Calendar', CalendarDays],
  ['drafts', 'Drafts', FileText],
  ['audit', 'Audit', ScrollText],
];

export default function AgentSettings() {
  const [tab, setTab] = useState('settings');
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('connected') === 'google') {
      setBanner('Google Calendar connected.');
      setTab('calendar');
      params.delete('connected');
      const qs = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? `?${qs}` : ''));
    }
  }, []);

  return (
    <div className="agent-page">
      <div className="agent-hero">
        <div className="agent-hero-icon"><Sparkles size={24} /></div>
        <div>
          <h1 className="agent-title">Reply Agent</h1>
          <p className="agent-subtitle">
            Let AI triage, draft, and (optionally) send replies to your prospects — on your terms.
          </p>
        </div>
      </div>

      {banner && (
        <div className="agent-banner">
          <CheckCircle2 size={18} /> {banner}
        </div>
      )}

      <div className="agent-tabs">
        {TABS.map(([key, label, Icon]) => (
          <button key={key}
            className={`agent-tab ${tab === key ? 'active' : ''}`}
            onClick={() => setTab(key)}>
            <Icon size={16} /> {label}
          </button>
        ))}
      </div>

      <div className="agent-card">
        {tab === 'settings' && <SettingsTab />}
        {tab === 'calendar' && <CalendarTab />}
        {tab === 'drafts' && <DraftsTab />}
        {tab === 'audit' && <AuditTab />}
      </div>
    </div>
  );
}
